module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Book.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Book.eot
 ** module id = 344
 ** module chunks = 0
 **/